// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-data-table td.text-start {\n  padding: 0 8px;\n}\n.v-treeview-node__level {\n  width: 18px;\n}\n.folder-actions {\n  display: none;\n}\n.v-treeview-node__root:hover .folder-actions {\n  color: red;\n  display: initial;\n}", ""]);
// Exports
module.exports = exports;
